var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1.11rem",
    height: "1.11rem",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    alt: "Required Attention Soon Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.1,17.2L11.2,1.6C11,1.2,10.6,1,10.2,1h0c-0.4,0-0.8,0.2-1,0.6L1.3,17.2c-0.2,0.4-0.2,0.8,0,1.2 c0.2,0.4,0.6,0.6,1,0.6h15.8c0.4,0,0.8-0.2,1-0.6C19.2,18.1,19.2,17.6,19.1,17.2z M10.2,16.6c-0.6,0-1.1-0.5-1.1-1.2 c0-0.7,0.5-1.2,1.1-1.2c0.6,0,1.1,0.5,1.1,1.2C11.3,16.1,10.8,16.6,10.2,16.6z M11.3,11.8c0,0.7-0.5,1.2-1.1,1.2 c-0.6,0-1.1-0.5-1.1-1.2V7c0-0.7,0.5-1.2,1.1-1.2c0.6,0,1.1,0.5,1.1,1.2V11.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.5656f336.svg";
export { ForwardRef as ReactComponent };